import styled, { css, keyframes } from "styled-components";
import { colors, header } from "../../../styles/variables";
import breakpoints from "../../../styles/breakpoints";
import TrayContainer from "../../atoms/TrayContainer";

const sheetApearing = keyframes`
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
`;

const sheetDisappearing = keyframes`
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(140%);
  }
`;

export const StyledBoxTray = styled(TrayContainer)<{
  isInBoxAndCartTray: boolean;
  isOpened: boolean;
  hide: boolean;
}>`
  background-color: ${colors.white};
  ${breakpoints.xsUp} {
    width: 500px;
  }
  ${breakpoints.xsDown} {
    width: 100%;
  }
  max-height: 100%;
  z-index: 2200;
  ${breakpoints.mdUp} {
    ${(props) =>
      !props.isInBoxAndCartTray &&
      css`
        top: ${header.desktopHeight};
      `}
  }
  ${breakpoints.smDown} {
    min-height: 100%;
  }
  ${(props) =>
    !props.isOpened &&
    css`
      display: none;
    `}
  display: flex;
  animation: ${(props) => (props.hide ? sheetDisappearing : sheetApearing)};
  animation-duration: 0.4s;
`;

export const loadingStyle = css`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  width: 100%;
  min-height: 240px;
`;
